"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "olbia": {
    "302181cc": [{
      "hkey": "a21c545d",
      "slug": "portisco-milmeggiu",
      "name": "Portisco-Milmeggiu",
      "primary": true,
      "skipSearch": false
    }],
    "milmegghio-portisco": [{
      "hkey": "a21c545d",
      "slug": "portisco-milmeggiu",
      "name": "Portisco-Milmeggiu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aa20d3d7": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "skipSearch": false
    }],
    "bados": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "6f3538ba": [{
      "hkey": "c78f30ce",
      "slug": "li-cuncheddi-bunthe",
      "name": "Li Cuncheddi-Bunthe",
      "primary": true,
      "skipSearch": false
    }],
    "bunthe": [{
      "hkey": "c78f30ce",
      "slug": "li-cuncheddi-bunthe",
      "name": "Li Cuncheddi-Bunthe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "12065647": [{
      "hkey": "429867ec",
      "slug": "contras-ludos-santa-mariedda",
      "name": "Contras-Ludos-Santa Mariedda",
      "primary": true,
      "skipSearch": false
    }],
    "contras": [{
      "hkey": "429867ec",
      "slug": "contras-ludos-santa-mariedda",
      "name": "Contras-Ludos-Santa Mariedda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b31a2af4": [{
      "hkey": "8266edaf",
      "slug": "cugnana-verde",
      "name": "Cugnana Verde",
      "primary": true,
      "skipSearch": false
    }],
    "cugnana": [{
      "hkey": "8266edaf",
      "slug": "cugnana-verde",
      "name": "Cugnana Verde",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "39943c44": [{
      "hkey": "f75b656a",
      "slug": "porto-rotondo",
      "name": "Porto Rotondo",
      "primary": true,
      "skipSearch": false
    }],
    "golfo-di-marinella": [{
      "hkey": "f75b656a",
      "slug": "porto-rotondo",
      "name": "Porto Rotondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "2ae73099": [{
      "hkey": "1acd63e0",
      "slug": "lido-del-sole-vecchie-saline",
      "name": "Lido del Sole-Vecchie Saline",
      "primary": true,
      "skipSearch": false
    }],
    "le-vecchie-saline": [{
      "hkey": "1acd63e0",
      "slug": "lido-del-sole-vecchie-saline",
      "name": "Lido del Sole-Vecchie Saline",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9ea7d8db": [{
      "hkey": "c78f30ce",
      "slug": "li-cuncheddi-bunthe",
      "name": "Li Cuncheddi-Bunthe",
      "primary": true,
      "skipSearch": false
    }],
    "li-cuncheddi": [{
      "hkey": "c78f30ce",
      "slug": "li-cuncheddi-bunthe",
      "name": "Li Cuncheddi-Bunthe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9a71db86": [{
      "hkey": "1acd63e0",
      "slug": "lido-del-sole-vecchie-saline",
      "name": "Lido del Sole-Vecchie Saline",
      "primary": true,
      "skipSearch": false
    }],
    "lido-del-sole": [{
      "hkey": "1acd63e0",
      "slug": "lido-del-sole-vecchie-saline",
      "name": "Lido del Sole-Vecchie Saline",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "93f74447": [{
      "hkey": "281e5d5b",
      "slug": "mannazzu-lu-sticcadu",
      "name": "Mannazzu-Lu Sticcadu",
      "primary": true,
      "skipSearch": false
    }],
    "lu-sticcadu": [{
      "hkey": "281e5d5b",
      "slug": "mannazzu-lu-sticcadu",
      "name": "Mannazzu-Lu Sticcadu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "57665304": [{
      "hkey": "429867ec",
      "slug": "contras-ludos-santa-mariedda",
      "name": "Contras-Ludos-Santa Mariedda",
      "primary": true,
      "skipSearch": false
    }],
    "ludos": [{
      "hkey": "429867ec",
      "slug": "contras-ludos-santa-mariedda",
      "name": "Contras-Ludos-Santa Mariedda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "7ba1ce01": [{
      "hkey": "db956c43",
      "slug": "murta-maria",
      "name": "Murta Maria",
      "primary": true,
      "skipSearch": false
    }],
    "maltineddu": [{
      "hkey": "db956c43",
      "slug": "murta-maria",
      "name": "Murta Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "1d93359e": [{
      "hkey": "281e5d5b",
      "slug": "mannazzu-lu-sticcadu",
      "name": "Mannazzu-Lu Sticcadu",
      "primary": true,
      "skipSearch": false
    }],
    "mannazzu": [{
      "hkey": "281e5d5b",
      "slug": "mannazzu-lu-sticcadu",
      "name": "Mannazzu-Lu Sticcadu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "71a1c441": [{
      "hkey": "f75b656a",
      "slug": "porto-rotondo",
      "name": "Porto Rotondo",
      "primary": true,
      "skipSearch": false
    }],
    "marinella": [{
      "hkey": "f75b656a",
      "slug": "porto-rotondo",
      "name": "Porto Rotondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "65c2836a": [{
      "hkey": "a21c545d",
      "slug": "portisco-milmeggiu",
      "name": "Portisco-Milmeggiu",
      "primary": true,
      "skipSearch": false
    }],
    "milmeggiu": [{
      "hkey": "a21c545d",
      "slug": "portisco-milmeggiu",
      "name": "Portisco-Milmeggiu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9b17e20e": [{
      "hkey": "ed962260",
      "slug": "putzolu-monte-telti",
      "name": "Putzolu-Monte Telti",
      "primary": true,
      "skipSearch": false
    }],
    "monte-telti": [{
      "hkey": "ed962260",
      "slug": "putzolu-monte-telti",
      "name": "Putzolu-Monte Telti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "5027d317": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "skipSearch": false
    }],
    "moriscu": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "c9a64dca": [{
      "hkey": "4608f166",
      "slug": "olbia",
      "name": "Olbia",
      "primary": true,
      "skipSearch": false
    }],
    "nodu-pianu": [{
      "hkey": "4608f166",
      "slug": "olbia",
      "name": "Olbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "030c488d": [{
      "hkey": "429867ec",
      "slug": "contras-ludos-santa-mariedda",
      "name": "Contras-Ludos-Santa Mariedda",
      "primary": true,
      "skipSearch": false
    }],
    "paule-lada": [{
      "hkey": "429867ec",
      "slug": "contras-ludos-santa-mariedda",
      "name": "Contras-Ludos-Santa Mariedda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "dc0737a5": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "skipSearch": false
    }],
    "pittulongu": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4d4b1a4b": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "skipSearch": false
    }],
    "pittulongu-mare-e-rocce": [{
      "hkey": "1dd990c0",
      "slug": "pittulongu-bados",
      "name": "Pittulongu-Bados",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "6a44f5a7": [{
      "hkey": "a21c545d",
      "slug": "portisco-milmeggiu",
      "name": "Portisco-Milmeggiu",
      "primary": true,
      "skipSearch": false
    }],
    "portisco": [{
      "hkey": "a21c545d",
      "slug": "portisco-milmeggiu",
      "name": "Portisco-Milmeggiu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0200656c": [{
      "hkey": "4608f166",
      "slug": "olbia",
      "name": "Olbia",
      "primary": true,
      "skipSearch": false
    }],
    "priatu": [{
      "hkey": "4608f166",
      "slug": "olbia",
      "name": "Olbia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec9feded": [{
      "hkey": "ed962260",
      "slug": "putzolu-monte-telti",
      "name": "Putzolu-Monte Telti",
      "primary": true,
      "skipSearch": false
    }],
    "putzolu": [{
      "hkey": "ed962260",
      "slug": "putzolu-monte-telti",
      "name": "Putzolu-Monte Telti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "83227a8e": [{
      "hkey": "bd139954",
      "slug": "olbia-citta",
      "name": "Olbia città",
      "primary": true,
      "skipSearch": false
    }],
    "sporula": [{
      "hkey": "bd139954",
      "slug": "olbia-citta",
      "name": "Olbia città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }],
    "12afc4dd": [{
      "hkey": "b51da9cc",
      "slug": "san-vittore",
      "name": "San Vittore",
      "primary": true,
      "skipSearch": false
    }],
    "teggia-de-sambene": [{
      "hkey": "b51da9cc",
      "slug": "san-vittore",
      "name": "San Vittore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olbia"
    }]
  }
};
exports["default"] = _default;